import React from "react";
import { Card, Col, message, Row, } from "antd";
import * as _ from "lodash";
import { PostRequestResolve } from "utils/FetchHelper";
import URL from "utils/url";


// Configuration React Functional Component
function Configuration({ accountDetails }) {
    const acctName = _.get(accountDetails, "Name", "");

    const [tablesCount, setTablesCount] = React.useState({});
    const [tablesCountLoading, setTablesCountLoading] = React.useState(false);

    // fetch tables count using api
    const fetchTablesCount = async () => {
        setTablesCountLoading(true);
        const payload = {
            name: acctName,
        };
        PostRequestResolve(URL.getAccountTables, null, payload)
            .then((response) => {
                setTablesCount(response);
            })
            .catch(() => {
                message.error("Failed to fetch entitlement history");
            }).finally(() => {
                setTablesCountLoading(false);
            }
            );
    }


    React.useEffect(() => {
        if (acctName) {
            fetchTablesCount();
        }
    }, [acctName]);

    return (
        <Card type="inner" title="Configuration" loading={tablesCountLoading}>
            <Row>
                <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                    <p>
                        <b>Active Gateways</b> :{" "}
                        {_.get(
                            accountDetails,
                            "Configuration.active_gateways",
                            0
                        )}
                    </p>
                </Col>
                <Col xs={24} sm={24} md={12} lg={8} xl={6}>
                    <p>
                        <b>Inactive Gateways</b> :{" "}
                        {_.get(
                            accountDetails,
                            "Configuration.inactive_gateways",
                            0
                        )}
                    </p>
                </Col>
                {_.map(
                    tablesCount,
                    (value, key) => (
                         <Col
                                key={_.replace(key, " ", "")}
                                xs={24}
                                sm={24}
                                md={12}
                                lg={8}
                                xl={6}
                            >
                                <p>
                                    <b>{key}</b> :{" "}
                                    {value}
                                </p>
                            </Col>
                    )
                )}
            </Row>
        </Card>
    );
}

export default Configuration;